import { gql } from '__generated__/gql';

export const CREATE_COMMENT_ON_ACTIVITY_ASSIGNMENT = gql(/* GraphQL */ `
  mutation createCommentOnActivityAssignment($input: CreateCommentOnActivityAssignmentInput!) {
    createCommentOnActivityAssignment(input: $input) {
      success
      error
    }
  }
`);
